var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIdea(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32.525,
    height: 37.349,
    viewBox: "0 0 32.525 37.349",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "idea",
    transform: "translate(-33.066)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_710",
    "data-name": "Path 710",
    d: "M123.78,99.578a8.761,8.761,0,0,1,2.646-4.046,10.629,10.629,0,0,0,3.813-8.17,10.74,10.74,0,1,0-17.663,8.17,8.348,8.348,0,0,1,2.723,4.046Z",
    transform: "translate(-70.172 -71.022)",
    fill: "#ffd15c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_711",
    "data-name": "Path 711",
    d: "M202.191,229.45h.7l-3.112-11.594h.233a1.536,1.536,0,0,0,1.089-.467.752.752,0,0,1,1.089,0,1.329,1.329,0,0,0,2.023,0,.707.707,0,0,1,.545-.233.841.841,0,0,1,.545.233,1.413,1.413,0,0,0,1.089.467h.233l-3.035,11.594h.7l3.19-12.138c0-.156,0-.311-.156-.389a.342.342,0,0,0-.389.078.673.673,0,0,1-.467.233,1.035,1.035,0,0,1-.622-.233,1.329,1.329,0,0,0-2.023,0,.752.752,0,0,1-1.089,0,1.255,1.255,0,0,0-1.012-.467h0a1.255,1.255,0,0,0-1.012.467.883.883,0,0,1-.622.233.555.555,0,0,1-.467-.233.342.342,0,0,0-.389-.078.284.284,0,0,0-.156.389Z",
    transform: "translate(-153.875 -200.739)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1883",
    "data-name": "Group 1883",
    transform: "translate(45.127 28.478)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_712",
    "data-name": "Path 712",
    d: "M222.933,489.6a2.6,2.6,0,0,0,4.824,0Z",
    transform: "translate(-221.143 -482.364)",
    fill: "#344a5e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_713",
    "data-name": "Path 713",
    d: "M205.481,397.714H199.8a1.4,1.4,0,0,1-1.4-1.4V390.4h8.481v5.914A1.4,1.4,0,0,1,205.481,397.714Z",
    transform: "translate(-198.4 -390.4)",
    fill: "#344a5e"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1884",
    "data-name": "Group 1884",
    transform: "translate(44.271 29.723)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_714",
    "data-name": "Path 714",
    d: "M195.926,409.179h-8.4a.863.863,0,0,1-.856-.856h0a.863.863,0,0,1,.856-.856h8.4a.863.863,0,0,1,.856.856h0A.863.863,0,0,1,195.926,409.179Z",
    transform: "translate(-186.667 -407.467)",
    fill: "#415a6b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_715",
    "data-name": "Path 715",
    d: "M195.926,446.513h-8.4a.863.863,0,0,1-.856-.856h0a.863.863,0,0,1,.856-.856h8.4a.863.863,0,0,1,.856.856h0A.864.864,0,0,1,195.926,446.513Z",
    transform: "translate(-186.667 -442.078)",
    fill: "#415a6b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1885",
    "data-name": "Group 1885",
    transform: "translate(33.066)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_716",
    "data-name": "Path 716",
    d: "M246.111,0a.78.78,0,0,0-.778.778V3.424a.78.78,0,0,0,.778.778.735.735,0,0,0,.778-.778V.778A.78.78,0,0,0,246.111,0Z",
    transform: "translate(-229.849)",
    fill: "#ffd15c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_717",
    "data-name": "Path 717",
    d: "M96.257,62.1a.77.77,0,1,0-1.089,1.089l1.867,1.867a.77.77,0,1,0,1.089-1.089Z",
    transform: "translate(-90.421 -57.354)",
    fill: "#ffd15c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_718",
    "data-name": "Path 718",
    d: "M36.49,212.267H33.844a.78.78,0,0,0-.778.778h0a.78.78,0,0,0,.778.778H36.49a.78.78,0,0,0,.778-.778h0A.837.837,0,0,0,36.49,212.267Z",
    transform: "translate(-33.066 -196.783)",
    fill: "#ffd15c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_719",
    "data-name": "Path 719",
    d: "M97.034,337.3l-1.867,1.867a.77.77,0,0,0,1.089,1.089l1.867-1.867a.77.77,0,1,0-1.089-1.089Z",
    transform: "translate(-90.42 -312.479)",
    fill: "#ffd15c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_720",
    "data-name": "Path 720",
    d: "M371.456,337.3a.77.77,0,0,0-1.089,1.089l1.867,1.867a.77.77,0,1,0,1.089-1.089Z",
    transform: "translate(-345.545 -312.479)",
    fill: "#ffd15c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_721",
    "data-name": "Path 721",
    d: "M424.757,212.267h-2.646a.78.78,0,0,0-.778.778h0a.78.78,0,0,0,.778.778h2.646a.78.78,0,0,0,.778-.778h0A.78.78,0,0,0,424.757,212.267Z",
    transform: "translate(-393.01 -196.783)",
    fill: "#ffd15c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_722",
    "data-name": "Path 722",
    d: "M372.234,62.1l-1.867,1.867a.77.77,0,1,0,1.089,1.089l1.867-1.867a.77.77,0,0,0-1.089-1.089Z",
    transform: "translate(-345.545 -57.354)",
    fill: "#ffd15c"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIdea);
export default __webpack_public_path__ + "static/media/idea.9b1bd4f70776b3ca8ce8e6b6608546c8.svg";
export { ForwardRef as ReactComponent };